import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { IonSlides, ModalController } from '@ionic/angular';
import { Upload } from 'src/app/core/data/schema/upload';
import { ImageViewComponent } from 'src/app/core/component/image-view/image-view.component';

@Component({
  selector: 'app-content-preview',
  templateUrl: './content-preview.component.html',
  styleUrls: ['./content-preview.component.scss'],
})
export class ContentPreviewComponent implements OnInit {

  @ViewChild('slides', { static: true }) slides: IonSlides;
  @Input() files: Upload[] = [];
  @Input() allowRemove = false;
  @Input() showThumbnails = false;
  @Input() viewHeight = 150;
  @Input() thumbSize = 70;
  @Input() uploadTitle = 'Select a File';
  @Input() uploadDetails;
  @Output() browse: EventEmitter<any> = new EventEmitter();
  @Output() fileRemoved: EventEmitter<Upload> = new EventEmitter();

  activeIndex = 0;
  tsNow = 0;
  private currMax = 3;
  private currMin = 0;

  constructor(
    private modalCtrl: ModalController
  ) { }

  ngOnInit() {
    this.tsNow = new Date().valueOf();
  }

  slideChanged(event: any) {
    this.slides.getActiveIndex().then(idx => { this.activeIndex = idx; });
  }

  expandFile(file: Upload) {
    // this.navCtrl.navigateForward('/shared/content/view', { state: { file } });
  }

  next() {
    if (this.activeIndex + 1 < this.files.length) {
      this.setImage(this.activeIndex + 1);
    }
  }

  prev() {
    if (this.activeIndex > 0) {
      this.setImage(this.activeIndex - 1);
    }
  }

  videoClicked(event: Event) {
    event.preventDefault();
    event.stopPropagation();
  }

  setImage(index: number) {
    this.slides.slideTo(index);
    this.activeIndex = index;
  }

  imageAdded() {
    if (this.files.length > 0) {
      this.slides.update().then(() => {
        this.setImage(this.files.length - 1);
      });
    }
  }

  removeImage(file: Upload) {
    const idOf = this.files.indexOf(file);
    this.files.splice(idOf, 1);
    if (idOf < this.files.length) {
      this.activeIndex = idOf;
    } else if (this.files.length > 0) {
      this.activeIndex = this.files.length - 1;
    } else {
      this.activeIndex = 0;
    }
    this.fileRemoved.emit(file);
  }

  async openImagePreview(index) {
    const modal = await this.modalCtrl.create({
      component: ImageViewComponent,
      swipeToClose: true,
      componentProps: {
        images: this.files.map(f => f.safeUrl),
        index
      },
    });
    await modal.present();
  }

}
